import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Box, Button, Stack } from "@mui/material";

import { FormSelectField, FormTextField } from "@covertree/ui";
import { UnitLevelUnderwritingAnswers } from "@covertree/types";

import { QuestionModalProps } from "../underwritingQuestions";
import {
  mapBusinessNumberVisitorsCountToEnum,
  mapQuestionOptionsToFormOptions,
} from "../../../mappings/underwritingQuestionsMaps";
import { UnderwritingQuestionsForm } from "../../../validatorsAndTypes/underwritingQuestions";

export function BusinessOnPremisesForm({
  questions,
  closeModal,
}: QuestionModalProps) {
  const { formState, control } = useFormContext<UnderwritingQuestionsForm>();
  const daycareOnPremisesOptions = useMemo(
    () =>
      mapQuestionOptionsToFormOptions(
        questions?.[UnitLevelUnderwritingAnswers.DaycareOnPremises].options
      ),
    [questions]
  );
  const businessEmployeesOptions = useMemo(
    () =>
      mapQuestionOptionsToFormOptions(
        questions?.[UnitLevelUnderwritingAnswers.BusinessEmployeesOnPremises]
          .options
      ),
    [questions]
  );
  const visitorsInMonthOptions = useMemo(
    () =>
      questions?.[UnitLevelUnderwritingAnswers.VisitorsInAMonth].options?.map(
        (value) => ({
          label: value,
          value: mapBusinessNumberVisitorsCountToEnum[value],
        })
      ) ?? [],
    [questions]
  );

  return (
    <Stack spacing={4}>
      <Box>
        <FormSelectField
          control={control}
          name="daycareOnPremises"
          id="daycare-on-premises"
          dataTestId="daycare-on-premises"
          options={daycareOnPremisesOptions}
          label="Is there a daycare on the premises?"
        />
      </Box>
      <Box>
        <FormSelectField
          control={control}
          name="businessEmployeesOnPremises"
          id="business-employees-on-premises"
          dataTestId="business-employees-on-premises"
          options={businessEmployeesOptions}
          label="Are there any business employees on the premises? "
        />
      </Box>
      <Box>
        <FormSelectField
          control={control}
          name="visitorsInAMonth"
          id="possible-visitors-in-month-count"
          dataTestId="possible-visitors-in-month-count"
          options={visitorsInMonthOptions}
          label="How many visitors are there a month?"
        />
      </Box>
      <Box>
        <FormTextField
          rows={4}
          multiline
          control={control}
          name="businessDescription"
          id="type-of-business-description"
          dataTestId="type-of-business-description"
          label="Describe the type of business being run at the dwelling."
        />
      </Box>
      <Box>
        <Button
          type="button"
          onClick={closeModal}
          disabled={!formState.isValid}>
          Save
        </Button>
      </Box>
    </Stack>
  );
}
